import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import DogWalkingPage from "@/pages/DogWalkingPage";
import PetSittingPage from "@/pages/PetSittingPage";
import HomeVisitsPage from "@/pages/HomeVisitsPage";
import MeetTheGangPage from "@/pages/MeetTheGangPage";
import ReviewsPage from "@/pages/ReviewsPage";
import PricesPage from "@/pages/PricesPage";
import FaqsPage from "@/pages/FaqsPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/dog-walking" element={<DogWalkingPage />} />
          <Route path="/pet-sitting" element={<PetSittingPage />} />
          <Route path="/home-visits" element={<HomeVisitsPage />} />
          <Route path="/meet-the-gang" element={<MeetTheGangPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/prices" element={<PricesPage />} />
          <Route path="/faqs" element={<FaqsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
